// src/reducers/chatReducer.js

import {
  ROOM_LOADING,
  CHAT_ROOM_LOADING,
  CHAT_LIST_LOADING,
  CREATE_CHAT_ROOM_V2,
  FETCH_CHAT_ROOM_V2,
  GET_CHAT_ROOM,
  DELETE_CHAT_ROOM,
  CHAT_ROOM_PAGE,
  CLEAR_ALL,
  CLEAR_PENDING_MESSAGE,
  CLEAR_CREATED_ROOM,
  START_NEW_CHAT,
} from "../constants/actions";

const initialState = {
  chatData: null,
  isLoading: false,
  isLoadingList: false, // For GET_CHAT_ROOM
  isLoadingRoom: false, // For FETCH_CHAT_ROOM
  created: null,
  updated: null,
  chat_topics: [],
  pageNo: 1,
  pendingInitialMessage: null, // Add this to store initial message
  // Removed error field since it's handled in errorReducer
};

export default function chatTopics(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ROOM_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case CHAT_LIST_LOADING:
      return {
        ...state,
        isLoading: true,
        isLoadingList: true,
      };
    case CHAT_ROOM_LOADING:
      return {
        ...state,
        isLoading: true,
        isLoadingRoom: true,
      };
    case CHAT_ROOM_PAGE:
      return {
        ...state,
        pageNo: payload,
      };

    case GET_CHAT_ROOM:
      return {
        ...state,
        chat_topics: payload,
        isLoading: false,
        isLoadingList: false,
      };
    case FETCH_CHAT_ROOM_V2:
      return {
        ...state,
        [payload.id]: payload,
        chatData: payload,
        isLoading: false,
        isLoadingRoom: false,
      };
    case CREATE_CHAT_ROOM_V2: {
      return {
        ...state,
        created: payload, // Keep existing field
        pendingInitialMessage: action.pendingInitialMessage, // Store message
        isLoading: false,
      };
    }

    case CLEAR_PENDING_MESSAGE: {
      return {
        ...state,
        pendingInitialMessage: null,
      };
    }

    case CLEAR_CREATED_ROOM: {
      return {
        ...state,
        created: null,
        updated: null,
      };
    }

    case DELETE_CHAT_ROOM: {
      // Remove the deleted room from chat_topics array
      const updatedChatTopics = state.chat_topics?.chat_topics
        ? {
          ...state.chat_topics,
          chat_topics: state.chat_topics.chat_topics.filter(
            (topic) => topic.id !== payload.id
          )
        }
        : state.chat_topics?.filter
          ? state.chat_topics.filter((topic) => topic.id !== payload.id)
          : state.chat_topics;

      return {
        ...state,
        chat_topics: updatedChatTopics,
        isLoading: false,
        updated: Math.random(),
      };
    }

    case START_NEW_CHAT:
      return {
        ...state,
        chatData: true,
      };

    case CLEAR_ALL:
      return {
        ...initialState,
        isLoading: true,
      };

    default:
      return state;
  }
}
